import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-input',
    standalone: false,
    templateUrl: './input.component.html',
    styleUrl: './input.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputComponent implements OnChanges {
    @Input({ required: false }) label = '';
    @Input({ required: true }) placeholder = 'placeholder';
    @Input({ required: true }) type = 'text';
    @Input({ required: false }) value = '';
    @Input({ required: true }) required = false;
    @Input({ required: false }) control: FormControl = new FormControl('');
    @Input({ required: false }) readonly = false;
    @Input({ required: false }) isLeftIcon = false;
    @Input({ required: false }) isRightIcon = false;
    @Input({ required: false }) leftIconPath = '';
    @Input({ required: false }) rightIconPath = '';
    @Input({ required: false }) minValue!: number;
    @Input({ required: false }) maxValue!: number;
    @Input({ required: false }) maxLength!: number;
    @Input({ required: false }) minLength!: number;
    @Input() errorMessage?: { key: string; message: string } = { key: '', message: 'Required Field' };
    @Output() afterInput = new EventEmitter();
    @Output() afterBlur = new EventEmitter();
    @Output() afterFocus = new EventEmitter();
    @Output() afterIconClick = new EventEmitter();

    iconPositions: any = {};

    constructor(private translate: TranslateService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['value']) {
            this.control.patchValue(this.value);
        }
    }

    getErrorMessage() {
        if (this.control.hasError('required')) {
            return this.errorMessage?.key === 'required'
                ? `${this.translate.instant(this.label)} Is Required.`
                : 'Required Field';
        }
        if (this.control.hasError('min')) {
            return this.errorMessage?.key
                ? this.errorMessage?.message
                : this.label
                  ? `${this.translate.instant(this.label)} Should be greater than ${this.minValue}.`
                  : 'Required Field';
        }
        if (this.control.hasError('pattern')) {
            return this.errorMessage?.key
                ? this.errorMessage?.message
                : this.label
                  ? `Invalid Input Format for ${this.translate.instant(this.label)}`
                  : 'Invalid Input Format';
        }
        if (this.control.hasError('maxlength')) {
            return this.errorMessage?.key
                ? this.errorMessage?.message
                : this.label
                  ? `${this.translate.instant(this.label)} Should be less than ${this.maxLength} characters.`
                  : 'Required Field';
        }
        if (this.control.hasError('max')) {
            return this.errorMessage?.key
                ? this.errorMessage?.message
                : this.label
                  ? `${this.translate.instant(this.label)} Should be less than ${this.maxValue}.`
                  : 'Required Field';
        }
        if (this.control.hasError('minlength')) {
            return this.errorMessage?.key
                ? this.errorMessage?.message
                : this.label
                  ? `${this.translate.instant(this.label)} Should be more than ${this.minLength}. characters`
                  : 'Required Field';
        }
        if (this.control.hasError('numberAndCommaOnly')) {
            return this.errorMessage?.key
                ? this.errorMessage?.message
                : this.label
                  ? `${this.translate.instant(this.label)} Should be number and comma only`
                  : 'Invalid Input Format';
        }
        if (this.control.hasError('alphabetOnly')) {
            return this.errorMessage?.key
                ? this.errorMessage?.message
                : this.label
                  ? `${this.translate.instant(this.label)} Should be alphabet only`
                  : 'Invalid Input Format';
        }
        if (this.control.hasError('latLon')) {
            return this.errorMessage?.key
                ? this.errorMessage?.message
                : this.label
                  ? `${this.translate.instant(this.label)} should contain only valid latitude/longitude format (numbers and period).`
                  : 'Invalid coordinate format';
        }
        return '';
    }
}
